import { normalize } from 'normalizr';
import * as schema from '../schema';
import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';



export const getProductSystem = (state, productSystemId) => {
  if (state.inventory !== undefined && state.inventory.productSystems !== undefined) {
    const x = Object.values(state.inventory.productSystems).filter(x => x.id === productSystemId);
    return (Array.isArray(x))? x[0] : undefined;
  } else {
    return [];
  }
}


export const fetchProductSystemStart = (  ) => {
    return {
        type: actionTypes.FETCH_PRODUCT_SYSTEM_START
    };
};

export const fetchProductSystemSuccess = ( productSystems ) => {
    return {
        type: actionTypes.FETCH_PRODUCT_SYSTEM_SUCCESS,
        values: productSystems
    };
};

export const fetchProductSystemFailed = () => {
    return {
        type: actionTypes.FETCH_PRODUCT_SYSTEM_FAILED
    };
};

export const fetchProductSystem = (productSystemId) => {
    const url = '/api/product_systems/' + productSystemId

    return dispatch => {
        dispatch( fetchProductSystemStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalized = normalize(response.data, { product_systems: schema.arrayOfProductSystems  })
               dispatch(fetchProductSystemSuccess(normalized));
               return normalized.result.product_systems
;            } )
            .catch( error => {
                dispatch(fetchProductSystemFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product_systems.js